const extractRoamingZone = (text: string): string | null => {
  if (text.includes('RLH2')) return 'ROAM_LIKE_HOME2';
  if (text.includes('RLH')) return 'ROAM_LIKE_HOME';
  const zoneMatch = text.includes('ROAMING') && text.match(/G(\d+)/);
  return zoneMatch ? zoneMatch[1] : null;
};

export const extractRoamingZoneFromArrayElements = (array: Object[], elementKey: string): string | null => {
  const roamingItem = array.find(
    item => item[elementKey] && (item[elementKey].includes('ROAMING') || item[elementKey].includes('RLH'))
  );
  if (roamingItem) {
    return extractRoamingZone(roamingItem[elementKey]);
  }

  return null;
};

export default extractRoamingZone;
